import React, { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useFormik } from "formik";
import { Button, Col, Form, Row, Tab, Tabs } from "react-bootstrap";
import { BsDownload } from "react-icons/bs";
import { GoAlert } from "react-icons/go";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import ReactTooltip from "react-tooltip";
import * as Yup from "yup";
// import { saveAs } from "file-saver";
import { VscReplace } from "react-icons/vsc";
import { BiEdit } from "react-icons/bi";
import DOMPurify from "dompurify";
import ButtonImagePermission from "../../components/UI/Button/ButtonImagePermission";
import CheckBoxProcedimentosFormik from "../../components/UI/Checkbox/CheckBoxProcedimentosFormik";
import DateTimeInputFormik from "../../components/UI/DateTimeInput/DateTimeInputFormik";
import FormAlert from "../../components/UI/FormAlert/FormAlert";
import HtmlEditor from "../../components/UI/HtmlEditorInput/HtmlEditor";
import OverlayInfoAdicional from "../../components/UI/Overlays/OverlayInfoAdicional";
import SelectDiretor from "../../components/UI/SelectInput/SelectDiretor";
import SelectInputCachedFormik from "../../components/UI/SelectInput/SelectInputCachedFormik";
import TextInputFormik from "../../components/UI/TextInput/TextInputFormik";
import funcionalidades from "../../context/AuthContext.funcionalidades";
import useApiClient, { apiRoutes } from "../../hooks/apiClient";
import ListaContribuinteAcaoFiscal from "../SPF/ListaContribuinteAcaoFiscal";
import ListaExecutores from "./ListaExecutores";
import useSetGuard from "../../hooks/useSetGuard";
import { signalrActions } from "../../redux/signalr";
import TextSpinner from "../../components/UI/Spinner/TextSpinner";
import useGerarOrdemServico from "./hooks/useGerarOrdemServico";
import useDocumentoParteServico from "./ParteServico/hooks/useDocumentoParteServico";
import FileDownloader from "../../components/UI/Button/FileDownloader";
import useBuscaTextoPadraoOs from "./hooks/useBuscaTextoPadraoOs";
import EfisModal from "../../components/UI/EfisModal/EfisModal";

const validationSchema = Yup.object().shape({
  sequencialTipoAcao: Yup.string().default("").required("Informe o tipo de ação fiscal"),
  dataInicio: Yup.date().required("Informe a data inicial da fiscalização"),
  dataFim: Yup.date().required("Informe a data final da fiscalização"),
  contribuintes: Yup.array()
    .default([])
    .test("qtd-contribuinte", "Selecione pelo menos 1 contribuinte", (value) => (value || []).length > 0),
  textoPadrao: Yup.string().default("").required("Informe o texto complementar"),
  quantidadeDiasOs: Yup.number()
    .required("Informe a quantidade máxima de dias da OS")
    .positive()
    .integer()
    .min(1, "Valor mínimo deve ser 1")
    .max(60, "Valor máximo deve ser 60"),
  procedimentos: Yup.array().default([]),
  codigoDiretor: Yup.string().default("").required("Informe o Diretor"),
  listaExecutoresOs: Yup.array()
    .default([])
    .test("qtd-executor", "Selecione pelo menos 1 executor", (value) => (value || []).length > 0),
  numeroAberturaProcesso: Yup.string().default(""),
  sequencialDenuncia: Yup.string().default(""),
  sequencialParteServico: Yup.string().default(""),
});
const initialValues = {};
validationSchema._nodes.forEach((key) => {
  if (key === "procedimentos" || key === "contribuintes" || key === "listaExecutoresOs") {
    initialValues[key] = [];
  } else if (key === "quantidadeDiasOs") {
    initialValues[key] = 60;
  } else {
    initialValues[key] = "";
  }
});

const documentoParteServico = { exibir: () => {} };

const exibirDocumento = (sqParteServico) => {
  documentoParteServico.exibir(sqParteServico);
};

const FormOrigemGerarOs = ({ history, location }) => {
  const { state } = location;
  const [title, setTitle] = useState("");
  const [documentoContribuinte, setDocumentoContribuinte] = useState("");
  const [sqOrgao, setSqOrgao] = useState();
  const [sgOrgao, setSgOrgao] = useState("");
  const [listaOs, setListaOs] = useState([]);
  const setGuardClient = useSetGuard();
  const { setDocParams } = useDocumentoParteServico();
  const [desabilitarBotao, setDesabilitarBotao] = useState(false);

  documentoParteServico.exibir = (sqParteServico) => {
    setDocParams({ sqParteServico });
  };

  const { filaAssinaturaSucessoStateKey, filaAssinaturaFalhaStateKey } =
    useSelector((reduxState) => reduxState.signalr) || {};

  const dispatch = useDispatch();

  const { request: requestSafePayload, data: dataSafePayload } = useApiClient();

  const formik = useFormik({
    initialValues,
    validationSchema,
  });

  const { gerarOrdemServico, gerarOrdemServicoIsLoading, gerarOrdemServicoErrors, gerarOrdemServicoData } =
    useGerarOrdemServico({ formik });

  const { textoPadrao } = useBuscaTextoPadraoOs({ formik });

  const [showTextoOs, setShowTextoOs] = useState(true);
  const [showViewSubstituicao, setShowViewSubstituicao] = useState(false);
  const [textoBody, setTextoBody] = useState("");

  const { setValues } = formik;

  useEffect(() => {
    if (gerarOrdemServicoData) {
      const listaTicket = [];
      const listaOS = [];

      gerarOrdemServicoData.result.value.forEach((x) => {
        listaTicket.push(x.ticket);
        listaOS.push(x.nuOrdemServico);
      });
      setListaOs(listaOS);
      requestSafePayload(apiRoutes.usuarios.arquivo.selecionar, listaTicket);
    }
  }, [gerarOrdemServicoData, requestSafePayload]);

  const assinaturaHandler = useCallback(
    (safePayload) => {
      setGuardClient.assinar(safePayload);
    },
    [setGuardClient],
  );
  useEffect(() => {
    if (dataSafePayload) {
      assinaturaHandler(dataSafePayload.result);
    }
  }, [dataSafePayload, assinaturaHandler]);

  // -- retorno da assinatura do documento

  const { push } = history;

  useEffect(() => {
    if (filaAssinaturaSucessoStateKey) {
      toast.success(`Ordem(ns) de Serviço ${listaOs} gerada(s) com sucesso.`);
      push({
        pathname: "/app/os/origem",
        state: { tipoOrigem: state.tipoOrigem },
      });
    }
    return () => {
      dispatch(signalrActions.clearState("filaAssinaturaSucessoStateKey"));
    };
  }, [dispatch, push, filaAssinaturaSucessoStateKey, state.tipoOrigem, listaOs]);

  useEffect(() => {
    dispatch(signalrActions.clearState("filaAssinaturaFalhaStateKey"));
  }, [dispatch, filaAssinaturaFalhaStateKey]);

  // -- fim retorno da assinatura do documento

  const { setFieldValue } = formik;
  useEffect(() => {
    if (state && state.tipoOrigem) {
      if (state.tipoOrigem === "D") {
        setFieldValue("sequencialDenuncia", state.sequencialOrigem);
        setTitle("Denúncia");
      } else if (state.tipoOrigem === "P") {
        setFieldValue("sequencialParteServico", state.sequencialOrigem);
        setTitle("Parte de Serviço");
      } else if (state.tipoOrigem === "C") {
        setFieldValue("sequencialCobranca", state.sequencialOrigem);
        setTitle("Cobrança");
      }
      if (state.documento) {
        setDocumentoContribuinte(state.documento);
      }
    }
  }, [state, setFieldValue]);

  // Trazer orgão do usuário logado
  const { request: requestOrgao, data: dataOrgao, errors: errorOrgao, isLoading: isLoadingOrgao } = useApiClient();

  useEffect(() => {
    requestOrgao(apiRoutes.fiscalizacao.ordemservico.consultaOrgaoLogado);
  }, [requestOrgao]);

  useEffect(() => {
    if ((!dataOrgao && !errorOrgao) || isLoadingOrgao) return;
    if (dataOrgao && dataOrgao.result.length) {
      setSqOrgao(dataOrgao.result[0].sequencialOrgao);
      setSgOrgao(dataOrgao.result[0].siglaOrgao);
    }
  }, [setSqOrgao, setSgOrgao, dataOrgao, errorOrgao, isLoadingOrgao]);
  // -------------
  useEffect(() => {
    setValues((curr) => ({
      ...curr,
      textoPadraoOs: textoPadrao,
    }));
  }, [setValues, textoPadrao]);
  return (
    <>
      {setGuardClient.linkRef} {/* Cabeçalho da Página */}
      <EfisModal
        show={showViewSubstituicao}
        title="Texto da OS"
        size="lg"
        closeHandler={() => setShowViewSubstituicao(false)}
        primaryLabelVisible={false}
        secondaryLabel="Fechar"
        body={<span dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(textoBody) }} />}
      />
      <h1 className="h3 mb-4 text-gray-800">Gerar Ordem de Serviço</h1>
      <div className="row">
        <div className="col-lg-12">
          <div className="card shadow mb-4">
            <div className="card-header py-3">
              <Row>
                <Col sm="11">
                  <h6 className="m-0 font-weight-bold text-primary flex-grow-1">{`A partir de ${title}`}</h6>
                </Col>
                <Col sm="1" className="text-right">
                  <OverlayInfoAdicional data={formik.values} keyFieldName="sequencialOrdemServico" />
                </Col>
              </Row>
            </div>
            <div className="card-body">
              <FormAlert
                formik={formik}
                data={gerarOrdemServicoData}
                errors={gerarOrdemServicoErrors}
                isLoading={gerarOrdemServicoIsLoading}
              />
              <Form noValidate onSubmit={formik.handleSubmit}>
                <Tabs defaultActiveKey="geral" transition={false} id="tabSpf">
                  <Tab
                    eventKey="geral"
                    title={
                      <span>
                        <GoAlert
                          color="red"
                          size={15}
                          hidden={
                            !(
                              formik.errors.sequencialTipoAcaoFiscal ||
                              formik.errors.dataInicio ||
                              formik.errors.dataFim ||
                              formik.errors.DescricaoOs ||
                              formik.errors.quantidadeDiasOs ||
                              formik.errors.codigoDiretor ||
                              formik.errors.textoPadrao
                            )
                          }
                        />
                        {"   "} Dados Gerais
                      </span>
                    }
                  >
                    <br />
                    <Row hidden={state.tipoOrigem === ""}>
                      <Form.Group as={Col} sm={12} md={6} hidden={state.tipoOrigem === "S"}>
                        <Form.Label>
                          <ReactTooltip place="top" type="dark" effect="float" />
                          {`Nº da ${title}: `}
                          {state.tipoOrigem !== "P" && (
                            <Link
                              target="_top"
                              to={{
                                pathname: `/app/spf/pendencias/detalhe?itemKey=${state.sequencialOrigem}&origem=${state.tipoOrigem}`,
                                state: { itemKey: state.sequencialOrigem },
                              }}
                            >
                              <span data-tip={`Acesse a ${title}`}>{state.sequencialOrigem}</span>
                            </Link>
                          )}

                          {state.tipoOrigem === "P" && (
                            <Link
                              target="_top"
                              to={{
                                pathname: `/app/parteservico/form?itemKey=${state.sequencialOrigem}`,
                                state: { itemKey: state.sequencialOrigem },
                              }}
                            >
                              <span data-tip={`Acesse a ${title} Nº ${state.sequencialOrigem}`}>
                                {state.sequencialOrigem}
                              </span>
                            </Link>
                          )}
                        </Form.Label>
                        <Form.Label className="ml-2">
                          {state.row.documento && (
                            <FileDownloader binario={state.row.documento} tooltip="Visualizar Documento" />
                          )}

                          {!state.row.documento && (
                            <ButtonImagePermission
                              permission={funcionalidades.spf.download}
                              className="btn-lg text-success pa-0 p-0"
                              buttonImage={<BsDownload size="16" color="#e37023" />}
                              tooltipImage={`Visualizar Doc ${state.row.sequencial}`}
                              onClick={() => exibirDocumento(state.row.sequencial)}
                            />
                          )}
                        </Form.Label>
                      </Form.Group>
                    </Row>
                    <Row>
                      <Form.Group as={Col} sm={12} md={6}>
                        <Form.Label>Tipo de Ação Fiscal</Form.Label>
                        <SelectInputCachedFormik
                          formik={formik}
                          field="sequencialTipoAcao"
                          tipoItem="tipo-acao-fiscal-os"
                        />
                      </Form.Group>
                      <Form.Group className="form-group-periodos" as={Col} sm={12} md={6}>
                        <Form.Label>Período de Fiscalização</Form.Label>
                        <div className="form-inline">
                          <DateTimeInputFormik formik={formik} field="dataInicio" />
                          <Form.Label className="mx-3"> a </Form.Label>
                          <DateTimeInputFormik formik={formik} className="mx-3" field="dataFim" />
                        </div>
                      </Form.Group>
                    </Row>
                    <Row>
                      <Form.Group as={Col} sm={12} md={12}>
                        <CheckBoxProcedimentosFormik formik={formik} field="procedimentos" />
                      </Form.Group>
                    </Row>
                    {sgOrgao === "COFIS" ? (
                      <Row>
                        <Form.Group as={Col} sm={12} md={6}>
                          <Form.Label>Setor</Form.Label>
                          <SelectInputCachedFormik formik={formik} field="setor" tipoItem="orgaos-os" />
                        </Form.Group>
                      </Row>
                    ) : null}
                    <Row>
                      <Form.Group as={Col} sm={12} md={6}>
                        <SelectDiretor formik={formik} field="codigoDiretor" sqorgaologado={sqOrgao} />
                      </Form.Group>
                      <Form.Group as={Col} sm={12} md={3}>
                        <Form.Label>N° Máximo de Dias da OS</Form.Label>
                        <TextInputFormik
                          formik={formik}
                          field="quantidadeDiasOs"
                          defaultValue={60}
                          maxLength="3"
                          type="number"
                        />
                      </Form.Group>
                    </Row>
                    <Row>
                      <Form.Group as={Col} sm={12} md={12}>
                        <Form.Label>Texto Complementar</Form.Label>
                        <HtmlEditor formik={formik} field="textoPadrao" />
                      </Form.Group>
                    </Row>
                    <Row>
                      <Col>
                        <hr />
                        <Form.Label>
                          <strong>Texto da OS</strong>
                          <BiEdit
                            className="btn-lg  text-danger pa-0 p-0 btn btn-bg-transparent ml-2"
                            title={showTextoOs ? "Editar Texto" : "Fechar Edição"}
                            onClick={() => {
                              setShowTextoOs(!showTextoOs);
                            }}
                          />
                          <VscReplace
                            className="btn-lg  text-danger pa-0 p-0 btn btn-bg-transparent ml-2"
                            title="Visualizar texto com substituições"
                            onClick={() => {
                              setShowViewSubstituicao(true);
                              setTextoBody(formik.values.textoPadraoOs);
                            }}
                          />
                        </Form.Label>
                        {!showTextoOs && <HtmlEditor formik={formik} field="textoPadraoOs" rows="5" />}
                        <hr hidden={!showTextoOs} />
                        <br />
                      </Col>
                    </Row>
                  </Tab>
                  <Tab
                    eventKey="contribuinte"
                    title={
                      <span>
                        <GoAlert color="red" size={15} hidden={!formik.errors.contribuintes} />
                        {"   "} Contribuintes
                      </span>
                    }
                  >
                    <ListaContribuinteAcaoFiscal
                      formik={formik}
                      field="contribuintes"
                      documento={documentoContribuinte}
                      origem="OS-1"
                    />
                  </Tab>
                  <Tab
                    eventKey="listaExecutoresOs"
                    title={
                      <span>
                        <GoAlert color="red" size={15} hidden={!formik.errors.listaExecutoresOs} />
                        {"   "} Executores
                      </span>
                    }
                  >
                    <ListaExecutores formik={formik} field="listaExecutoresOs" />
                  </Tab>
                </Tabs>
                <Row>
                  <Col>
                    {formik.isSubmitting ? (
                      <TextSpinner text={`Gerando Ordem de Serviço a partir de ${title}...`} />
                    ) : (
                      <Button
                        variant="primary"
                        className="mr-3"
                        disabled={desabilitarBotao || !formik.isValid}
                        onClick={() => {
                          gerarOrdemServico();
                          setDesabilitarBotao(true);
                        }}
                      >
                        Gerar OS
                      </Button>
                    )}
                    {"    "}
                    {!formik.isSubmitting && (
                      <Button variant="light" className="mr-3" onClick={formik.handleReset}>
                        Limpar
                      </Button>
                    )}
                    {"    "}
                    {!formik.isSubmitting && (
                      <Button variant="danger" className="mr-3" onClick={() => history.goBack()}>
                        Cancelar
                      </Button>
                    )}
                  </Col>
                </Row>
              </Form>
            </div>
          </div>
        </div>
      </div>
      {/* fim da row */}
    </>
  );
};
export default FormOrigemGerarOs;
